import { Wrapper, IconWrapper } from '@/components/SpeedbumpCta.styles'
import { Heading } from '@big-red-group/storefront-common-ui'
import Icon from '@/components/Icons'

const SpeedbumpCta: React.FC<{ cta: string; link: string }> = ({ cta, link }) => {
  return (
    <Wrapper href={link} data-testid="speedbump-cta">
      <Heading size="M" as="h4" spacing={false} headingGraphic="stroke" headingGraphicStyle={{ fill: 'white' }}>
        {cta}
      </Heading>
      <IconWrapper>
        <Icon name="arrowCircleRightWhite" width={50} height={50} />
      </IconWrapper>
    </Wrapper>
  )
}

export default SpeedbumpCta
